import { Alert, AlertManager, useAlertCollection, useAlerts } from "client/Hooks";
import { ReactElement, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { AlertBarContainer } from "./AlertBarContainer";
import { AlertMessage, popAllMessages } from "./pageReloadAlerts";
import styles from "./GlobalAlertBarContainer.module.less";
import { ensureNotNil } from "client/Misc/utils";

const GlobalAlertBarContainer = (): ReactElement => {
	const alertManager: AlertManager = useAlerts();
	const alerts: readonly Alert[] = useAlertCollection();

	useEffect(
		(): void => {
			const messages: readonly AlertMessage[] = popAllMessages();

			for (const message of messages) {
				alertManager.show(message.type, message.text);
			}
		},
		[alertManager]
	);

	return (
		<div className={styles.root}>
			<AlertBarContainer
				trackingId="global-alert-bar-container"
				alertManager={alertManager}
				alerts={alerts}
			/>
		</div>
	);
};
GlobalAlertBarContainer.displayName = "GlobalAlertBarContainer";

export function initializeGlobalAlertBarContainer(): void {
	createRoot(
		ensureNotNil(
			document.getElementById("global-alert-bar-container")
		)
	)
		.render(
			<GlobalAlertBarContainer />
		);
}